import { apiRequest } from '../../apiCall'

export const getPaiedInvoice = () => apiRequest('paiedInvoice.GetAllPaidInvoices');
export const getInvoiceInPortal = (params) => apiRequest('paiedInvoice.GetInvoiceInPortal',params);
export const setIssueFactorType = (params) => apiRequest('paiedInvoice.SetIssueFactorType',params);

